import styled from 'styled-components'
import { TableDataListType } from '@app.feature/exam/gsat2024-2/modules/detailInfoArticleTableData.module'

type DetailInfoTableBodyProps = {
  tableDataList: TableDataListType
}

const DetailInfoTableBody = ({ tableDataList }: DetailInfoTableBodyProps) => {
  if (!tableDataList) {
    return null
  }

  return (
    <StyledWrapper>
      {Object.keys(tableDataList).map((key) => (
        <tr key={key}>
          <td>{key === 'math' ? '수리' : '추리'}</td>
          <td>{tableDataList[key]?.correctCount || 0}문항</td>
          <td className="correct-rate">
            {tableDataList[key]?.answeredCount || 0}문항
          </td>
          <td>{tableDataList[key]?.allUserAverageCorrectCount || 0}문항</td>
          <td className="correct-rate">
            {tableDataList[key]?.allUserAverageAnsweredCount || 0}문항
          </td>
          <td>{tableDataList[key]?.top30UserAverageCorrectCount || 0}문항</td>
          <td className="correct-rate">
            {tableDataList[key]?.top30UserAverageAnsweredCount || 0}문항
          </td>
          <td>{tableDataList[key]?.sameInfoAverageCorrectCount || 0}문항</td>
          <td className="correct-rate">
            {tableDataList[key]?.sameInfoAverageAnsweredCount || 0}문항
          </td>
          <td>
            {tableDataList[key]?.top30SameInfoAverageCorrectCount || 0}문항
          </td>
          <td className="correct-rate">
            {tableDataList[key]?.top30SameInfoAverageAnsweredCount || 0}문항
          </td>
        </tr>
      ))}
    </StyledWrapper>
  )
}

export default DetailInfoTableBody

const StyledWrapper = styled.tbody`
  > tr {
    > td {
      padding: 14px 0px;
      font-size: 15px;
      font-weight: 500;
      letter-spacing: -0.6px;
      text-align: center;
      color: #333;
      border: 1px solid #eeeeee;
      border-collapse: collapse;

      &:first-child {
        border-left: 0;
        background-color: #fafafa;
      }

      &:last-child {
        border-right: 0;
      }

      &.correct-rate {
        font-weight: bold;
      }
    }
  }
`
